import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { css } from '@emotion/core';
import {
    FacebookShareButton,
    LineShareButton,
    TwitterShareButton,
    WhatsAppShareButton
} from 'client/components/Result/Share/button';
import DialogContainer from 'components/common/Dialog/DialogContainer';
import { system900 } from 'Mui/styles/color';

const DialogShareButtonGroup = ({ open, onClose, url }) => {
    return (
        <DialogContainer
            title={i18n.t('label.share_dialog.title')}
            open={open}
            isFixedWindow={true}
            disableBackdrop={false}
            themeTextColor={system900.color}
            themeBgColor="#FFF"
            onClose={onClose}
        >
            <div css={containerStyle}>
                <FacebookShareButton url={url} />
                <LineShareButton url={url} />
                <TwitterShareButton url={url} />
                <WhatsAppShareButton url={url} />
            </div>
        </DialogContainer>
    );
};

export default DialogShareButtonGroup;

const containerStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    margin-bottom: 8px;
    gap: 16px;
`;

DialogShareButtonGroup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    url: PropTypes.string.isRequired
};
